export const POSITIONS_TAB_COPY = {
  Positions: { noun: 'open positions', empty: 'No open positions' },
  Assets: { noun: 'assets', empty: 'No assets' },
  'Open Orders': { noun: 'open orders', empty: 'No open orders' },
  TWAP: { noun: 'TWAPs', empty: 'No TWAPs' },
  Strategies: { noun: 'strategies', empty: 'No strategies' },
  'Order History': { noun: 'order history', empty: 'No order history' },
  'Trade History': { noun: 'trade history', empty: 'No trade history' },
  'Funding History': { noun: 'funding history', empty: 'No funding history' },
  Liquidations: { noun: 'liquidations', empty: 'No liquidations' },
  'Public Pools': { noun: 'public pools', empty: 'No public pools' },
  Deposits: { noun: 'deposits', empty: 'No deposits' },
  Withdrawals: { noun: 'withdrawals', empty: 'No withdrawals' },
  Transfers: { noun: 'transfers', empty: 'No transfers' },
  'My Activity': { noun: 'activity', empty: 'No activity' },
  'Pending Unstakes': { noun: 'pending unstakes', empty: 'No pending unstakes' },
  'Fee Credits': { noun: 'fee credits', empty: 'No fee credits' },
}

let signalPatternSeq = 0

export function positionsEmptyHtml({ connected, tab }) {
  const copy = POSITIONS_TAB_COPY[tab] || POSITIONS_TAB_COPY.Positions
  if (connected) {
    return `<div role="status" class="flex flex-col items-center justify-center gap-3 py-14 text-center max-mobile:justify-start max-mobile:py-8 max-mobile:flex-1 max-mobile:px-6" data-testid="positions-empty">
      <p class="max-w-[320px] text-sm/sm text-pretty text-dim">${copy.empty}</p>
    </div>`
  }
  const patternId = `positions-signal-${signalPatternSeq++}`
  return `<div role="status" class="flex flex-col items-center justify-center gap-3 py-14 text-center max-mobile:justify-start max-mobile:py-8 max-mobile:flex-1 max-mobile:px-6" data-testid="positions-disconnected">
    <span class="inline-flex" aria-hidden="true">
      <svg viewBox="0 0 44 44" class="size-14 overflow-visible">
        <defs>
          <pattern id="${patternId}" width="4" height="4" patternUnits="userSpaceOnUse">
            <rect x="0.65" y="0.65" width="2.7" height="2.7" fill="currentColor" fill-opacity="0.09"></rect>
          </pattern>
        </defs>
        <rect width="44" height="44" fill="url(#${patternId})" class="text-ink"></rect>
        <g data-positions-signal-bars></g>
      </svg>
    </span>
    <span class="font-mono label-meta text-md/md text-ink">Not connected</span>
    <p class="max-w-[320px] text-sm/sm text-pretty text-dim">Connect a wallet to see your ${copy.noun}.</p>
    <button type="button" class="inline-flex items-center gap-2 font-medium disabled:opacity-50 active:text-meta disabled:no-underline py-0.5 text-sm/sm text-meta underline underline-offset-2 hover:text-ink cursor-pointer">
      <span>Connect Wallet</span>
    </button>
  </div>`
}

export function signalCellOpacity(col, row, t) {
  const left = t * 5
  const right = 10 - t * 5
  const dist = Math.min(Math.abs(col - left), Math.abs(col - right))
  const inMidRows = Math.abs(row - 5) <= 1
  let op = 0
  if (inMidRows) {
    if (dist <= 1) op = 1
    else if (dist < 2.15) op = Math.max(0, 1 - (dist - 1) * 0.92)
  }
  const stretch = 1 + t * 1.15
  if (Math.abs(col - 5) < 0.51 && Math.abs(row - 5) <= stretch) {
    const vert = 0.35 + t * 0.55
    const rowFade = Math.abs(row - 5) <= 1 ? 1 : 0.92
    op = Math.max(op, vert * rowFade)
  }
  return op < 0.04 ? 0 : Math.min(1, op)
}

export function stopPositionsSignal(page) {
  if (page.__positionsSignalRaf) {
    cancelAnimationFrame(page.__positionsSignalRaf)
    page.__positionsSignalRaf = 0
  }
}

export function startPositionsSignal(page, root) {
  stopPositionsSignal(page)
  const group = root.querySelector('[data-positions-signal-bars]')
  if (!group) return
  const started = performance.now()
  const period = 2600
  const tick = (now) => {
    if (!group.isConnected) return
    const cycle = ((now - started) % period) / period
    const ping = cycle < 0.5 ? cycle * 2 : 2 - cycle * 2
    const t = ping * ping * (3 - 2 * ping)
    let html = ''
    for (let col = 0; col < 11; col += 1) {
      for (let row = 0; row < 11; row += 1) {
        const op = signalCellOpacity(col, row, t)
        if (!op) continue
        html += `<rect x="${0.65 + col * 4}" y="${0.65 + row * 4}" width="2.7" height="2.7" fill="currentColor" fill-opacity="${op}"></rect>`
      }
    }
    group.innerHTML = html
    page.__positionsSignalRaf = requestAnimationFrame(tick)
  }
  page.__positionsSignalRaf = requestAnimationFrame(tick)
}
